
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://orefbswiccpmhnvbrloe.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9yZWZic3dpY2NwbWhudmJybG9lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYxNjgzNTEsImV4cCI6MjA2MTc0NDM1MX0.m5Tg13svNzOaZhxZEOqgQ0lT97nppkQUvaXy11l1WrA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY, 
  {
    auth: {
      storage: localStorage, // Use localStorage for session persistence
      persistSession: true, // Persist the session
      autoRefreshToken: true, // Auto refresh the token
      detectSessionInUrl: true, // Detect session in URL for OAuth redirects
      flowType: 'pkce', // Use PKCE flow for added security
    }
  }
);
